<template>
	<div>
		<el-select style="width: 100%" v-model="selectedApplicant" placeholder="Select Customer">
			<el-option
				v-for="item in applicants"
				:key="item.applicantId"
				:label="`${item.firstName} ${item.lastName}`"
				:value="item.applicantId"
			></el-option>
		</el-select>

		<el-input
			v-if="selectedApplicant && selectedDocs && selectedDocs.filter((item) => item.applicant_id == selectedApplicant).length > 0"
			class="mt-4 mb-2"
			placeholder="Search Documents"
			v-model="searchDocuments"
			clearable
		></el-input>

		<el-table
			v-if="selectedApplicant && selectedDocs && selectedDocs.filter((item) => item.applicant_id == selectedApplicant).length > 0"
			:data="
				_.orderBy(documents, 'displayName', 'asc').filter(
					(data) => !searchDocuments || data.displayName.toLowerCase().includes(searchDocuments.toLowerCase())
				)
			"
			:show-header="false"
			:border="false"
			style="width: 100%"
		>
			<el-table-column width="50px">
				<template slot-scope="scope">
					<div class="amb-table-check-container">
						<input
							:ref="`document-${scope.row.id}`"
							class="table-checkbox"
							type="checkbox"
							:value="scope.row.id"
							v-model="
								selectedDocs.find((d) => {
									return d.applicant_id == selectedApplicant
								}).documents
							"
						/>
						<span class="amb-table-checkmark"></span>
					</div>
				</template>
			</el-table-column>

			<el-table-column prop="displayName"></el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		name: "ApplicationDocumentTable",
		props: {
			documents: {
				type: Array,
				required: true,
			},
			selectedDocuments: {
				type: Array,
				required: true,
			},
			applicants: {
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				selectedDocs: [],
				selectedApplicant: null,
				searchDocuments: "",
			}
		},
		watch: {
			selectedDocs: {
				handler(newVal, oldVal) {
					this.$emit("update:selectedDocuments", newVal)
				},
				deep: true,
			},
			selectedApplicant(newVal, oldVal) {
				if (newVal) {
					if (!this.selectedDocs.filter((d) => d.applicant_id == newVal).length) {
						this.addApplicantDocs(newVal)
					}
				}
			},
		},
		methods: {
			toggleSelection(row, column, cell, event) {
				this.$refs[`document-${row.id}`].checked = !this.$refs[`document-${row.id}`].checked
			},
			addApplicantDocs(applicantId) {
				this.selectedDocs.push({
					applicant_id: applicantId,
					documents: [],
				})
			},
		},
		mounted() {
			this.selectedDocs = this.selectedDocuments
			if (this.selectedDocs.length === 0) {
				this.applicants.forEach((applicant) => {
					let appDoc = { applicant_id: applicant.applicantId, documents: [] }
					this.selectedDocs.push(appDoc)
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	.cell {
		word-break: normal;
	}
</style>
